import { LitElement, html } from "lit";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { ContentMarketingSkeleton } from "../../../types/types-contentful.js";
import { PodletMetaData } from "../../../types/types-drEdition.js";
import { getPodletMetaData } from "../../lit-util.js";

class ContentfulPreviewWrapper extends LitElement {
	entryId: string;
	contentModel: ContentMarketingSkeleton["fields"];
	metaData: PodletMetaData;

	static properties = {
		entryId: { type: String },
		contentModel: { type: Object },
	};

	constructor() {
		super();
		this.entryId = "";
		this.contentModel = {} as ContentMarketingSkeleton["fields"];
		this.metaData = getPodletMetaData();
	}

	connectedCallback() {
		super.connectedCallback();
		this.initializeLivePreview();
	}

	initializeLivePreview() {
		ContentfulLivePreview.init({ locale: this.metaData.locale || "en-US" });

		ContentfulLivePreview.subscribe({
			data: this.contentModel,
			callback: (updatedData) => {
				console.log({ updatedData });
				// this.contentModel = updatedData.fields as unknown as ContentMarketingSkeleton["fields"];
				this.requestUpdate();
			},
		});
	}

	render() {
		const { entryId, contentModel, ...rest } = this;
		return html`
			<contentful-sponsor-header
				.id="${entryId}"
				logoImageData="${JSON.stringify(contentModel.advertiserLogo.fields)}"
			></contentful-sponsor-header>
			<contentful-teaser-wrapper
				.id="${entryId}"
				.contentModel="${contentModel}"
				...="${rest}"
			></contentful-teaser-wrapper>
		`;
	}
}

customElements.define("contentful-preview-wrapper", ContentfulPreviewWrapper);
